module.exports = __webpack_public_path__ + "img/star.dbf2f34b.svg";